// frontend/src/pages/customer/Profile.js - ЗАСВАРЛАСАН
import React, { useState, useEffect, useRef } from 'react';
import { useOutletContext } from 'react-router-dom';
import axios from '../../utils/axios';
import { toast } from 'react-toastify';
import {
  FiUser,
  FiMail,
  FiPhone,
  FiMapPin,
  FiBriefcase,
  FiEdit,
  FiSave,
  FiX,
  FiCreditCard,
  FiTrendingUp,
  FiPercent,
  FiCalendar,
  FiShield,
  FiAward,
  FiCheckCircle,
  FiXCircle,
  FiAlertCircle,
  FiCamera,
  FiLock
} from 'react-icons/fi';

const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  const baseURL = process.env.REACT_APP_API_URL || '${process.env.REACT_APP_API_URL}';
  if (imagePath.startsWith('/uploads')) {
    return `${baseURL}${imagePath}`;
  }
  return `${baseURL}/uploads/${imagePath}`;
};

const Profile = () => {
  const { user: contextUser } = useOutletContext();
  
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [uploadingImage, setUploadingImage] = useState(false);

  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    full_name: '',
    phone: '',
    address: '',
    company_name: '',
    password: '', // ✅ НЭМСЭН
    confirmPassword: '' // ✅ НЭМСЭН
  });

  const [changePassword, setChangePassword] = useState(false); // ✅ НЭМСЭН

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/customer/profile');
      
      if (response.data.success) {
        const userData = response.data.data.user;
        setProfile(userData);
        setFormData({
          full_name: userData.full_name || '',
          phone: userData.phone || '',
          address: userData.address || '',
          company_name: userData.company_name || '',
          password: '',
          confirmPassword: ''
        });
      }
    } catch (error) {
      console.error('❌ Fetch profile error:', error);
      toast.error('Хувийн мэдээлэл татахад алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.full_name || !formData.phone) {
      toast.error('Нэр болон утасны дугаар шаардлагатай');
      return;
    }

    // ✅ Нууц үг шалгах
    if (changePassword) {
      if (!formData.password || formData.password.length < 6) {
        toast.error('Нууц үг хамгийн багадаа 6 тэмдэгт байх ёстой');
        return;
      }
      if (formData.password !== formData.confirmPassword) {
        toast.error('Нууц үг таарахгүй байна');
        return;
      }
    }

    setSaving(true);
    try {
      const dataToSend = {
        full_name: formData.full_name,
        phone: formData.phone,
        address: formData.address,
        company_name: formData.company_name
      };

      // ✅ Нууц үг солих бол нэмэх
      if (changePassword && formData.password) {
        dataToSend.password = formData.password;
      }

      const response = await axios.put('/api/customer/profile', dataToSend);
      
      if (response.data.success) {
        toast.success('Мэдээлэл амжилттай шинэчлэгдлээ');
        setEditing(false);
        setChangePassword(false);
        setFormData({ ...formData, password: '', confirmPassword: '' });
        await fetchProfile();
      }
    } catch (error) {
      console.error('❌ Update profile error:', error);
      toast.error(error.response?.data?.message || 'Мэдээлэл шинэчлэхэд алдаа гарлаа');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (profile) {
      setFormData({
        full_name: profile.full_name || '',
        phone: profile.phone || '',
        address: profile.address || '',
        company_name: profile.company_name || '',
        password: '',
        confirmPassword: ''
      });
    }
    setChangePassword(false);
    setEditing(false);
  };

  // ✅ Profile зураг upload
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Зөвхөн зураг файл upload хийх боломжтой!');
      return;
    }

    // Validate file size (5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Зургийн хэмжээ 5MB-аас бага байх ёстой');
      return;
    }

    setUploadingImage(true);
    try {
      const formData = new FormData();
      formData.append('profile_image', file);

      const response = await axios.post('/api/customer/profile/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success) {
        toast.success('Profile зураг амжилттай солигдлоо');
        await fetchProfile();
      }
    } catch (error) {
      console.error('❌ Upload image error:', error);
      toast.error(error.response?.data?.message || 'Зураг upload хийхэд алдаа гарлаа');
    } finally {
      setUploadingImage(false);
    }
  };

  if (loading) {
    return (
      <div className="container-custom py-12">
        <div className="text-center">
          <div className="spinner-lg mx-auto mb-4"></div>
          <p className="text-gray-600">Уншиж байна...</p>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="container-custom py-12">
        <div className="text-center">
          <p className="text-red-600">Хувийн мэдээлэл олдсонгүй</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <div className="container-custom py-6">
        {/* Page Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Хувийн мэдээлэл</h1>
            <p className="text-gray-600 mt-1">Таны бүртгэлийн мэдээлэл</p>
          </div>
          {!editing && (
            <button
              onClick={() => setEditing(true)}
              className="btn btn-primary"
            >
              <FiEdit className="mr-2" />
              Засах
            </button>
          )}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left: Profile Card */}
          <div className="lg:col-span-2">
            <div className="card">
              {editing ? (
                <form onSubmit={handleSubmit}>
                  <div className="space-y-6">
                    {/* Profile Image + Name Header */}
                    <div className="flex items-center gap-4 pb-6 border-b border-gray-200">
                      {/* ✅ Profile Image Upload */}
                      <div className="relative">
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept="image/*"
                          onChange={handleImageUpload}
                          className="hidden"
                        />
                        
                        {profile.profile_image ? (
                          <img
                            src={getImageUrl(profile.profile_image)}
                            alt={profile.full_name}
                            className="w-20 h-20 rounded-full object-cover border-4 border-blue-100"
                          />
                        ) : (
                          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center border-4 border-blue-200">
                            <span className="text-3xl font-bold text-blue-700">
                              {formData.full_name.charAt(0).toUpperCase()}
                            </span>
                          </div>
                        )}
                        
                        <button
                          type="button"
                          onClick={() => fileInputRef.current?.click()}
                          disabled={uploadingImage}
                          className="absolute bottom-0 right-0 bg-blue-600 text-white p-2 rounded-full hover:bg-blue-700 transition-colors disabled:opacity-50"
                        >
                          {uploadingImage ? (
                            <div className="spinner w-4 h-4"></div>
                          ) : (
                            <FiCamera size={16} />
                          )}
                        </button>
                      </div>
                      
                      <div>
                        <h2 className="text-xl font-bold text-gray-900">Мэдээлэл засах</h2>
                        <p className="text-sm text-gray-600">Хувийн мэдээллээ шинэчлэх</p>
                      </div>
                    </div>

                    {/* Full Name */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Нэр <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <FiUser className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                          type="text"
                          value={formData.full_name}
                          onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                          className="input pl-10"
                          placeholder="Овог нэр"
                          required
                        />
                      </div>
                    </div>

                    {/* Phone */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Утасны дугаар <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <FiPhone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                          type="tel"
                          value={formData.phone}
                          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                          className="input pl-10"
                          placeholder="99119911"
                          required
                        />
                      </div>
                    </div>

                    {/* Company Name */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Байгууллагын нэр
                      </label>
                      <div className="relative">
                        <FiBriefcase className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                          type="text"
                          value={formData.company_name}
                          onChange={(e) => setFormData({ ...formData, company_name: e.target.value })}
                          className="input pl-10"
                          placeholder="Байгууллагын нэр"
                        />
                      </div>
                    </div>

                    {/* Address */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Хаяг
                      </label>
                      <div className="relative">
                        <FiMapPin className="absolute left-3 top-3 text-gray-400" />
                        <textarea
                          value={formData.address}
                          onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                          className="input pl-10"
                          rows="3"
                          placeholder="Дүүрэг, хороо, байр, тоот..."
                        />
                      </div>
                    </div>

                    {/* ✅ Нууц үг солих секц */}
                    <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg">
                      <label className="flex items-start cursor-pointer">
                        <input
                          type="checkbox"
                          checked={changePassword}
                          onChange={(e) => {
                            setChangePassword(e.target.checked);
                            if (!e.target.checked) {
                              setFormData({ ...formData, password: '', confirmPassword: '' });
                            }
                          }}
                          className="mt-1 w-5 h-5 text-blue-600"
                        />
                        <div className="ml-3 flex-1">
                          <span className="text-sm font-bold text-gray-900 flex items-center gap-2">
                            <FiLock size={16} />
                            Нууц үг солих
                          </span>
                          <p className="text-xs text-gray-600 mt-1">
                            Нууц үгээ шинэчлэх бол энэ сонголтыг идэвхжүүлнэ үү
                          </p>
                        </div>
                      </label>

                      {changePassword && (
                        <div className="mt-4 space-y-3">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Шинэ нууц үг <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="password"
                              value={formData.password}
                              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                              className="input"
                              placeholder="Шинэ нууц үг (хамгийн багадаа 6 тэмдэгт)"
                              minLength={6}
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Нууц үг давтах <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="password"
                              value={formData.confirmPassword}
                              onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                              className="input"
                              placeholder="Нууц үг давтах"
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-3 pt-4 border-t border-gray-200">
                      <button
                        type="submit"
                        disabled={saving}
                        className="btn btn-primary flex-1"
                      >
                        {saving ? (
                          <>
                            <div className="spinner-sm mr-2"></div>
                            Хадгалж байна...
                          </>
                        ) : (
                          <>
                            <FiSave className="mr-2" />
                            Хадгалах
                          </>
                        )}
                      </button>
                      <button
                        type="button"
                        onClick={handleCancel}
                        disabled={saving}
                        className="btn btn-secondary flex-1"
                      >
                        <FiX className="mr-2" />
                        Болих
                      </button>
                    </div>
                  </div>
                </form>
              ) : (
                <div className="space-y-6">
                  {/* Profile Header */}
                  <div className="flex items-center gap-4 pb-6 border-b border-gray-200">
                    {profile.profile_image ? (
                      <img
                        src={getImageUrl(profile.profile_image)}
                        alt={profile.full_name}
                        className="w-20 h-20 rounded-full object-cover border-4 border-blue-100"
                      />
                    ) : (
                      <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
                        <span className="text-3xl font-bold text-blue-700">
                          {profile.full_name.charAt(0).toUpperCase()}
                        </span>
                      </div>
                    )}
                    <div>
                      <h2 className="text-2xl font-bold text-gray-900">{profile.full_name}</h2>
                      <div className="flex items-center gap-2 mt-1">
                        <span className={`badge ${profile.customer_type === 'wholesale' ? 'badge-blue' : 'badge-green'}`}>
                          {profile.customer_type === 'wholesale' ? '🏢 Бөөний' : '🛒 Жижиглэн'}
                        </span>
                        {profile.verified ? (
                          <span className="badge badge-success">
                            <FiShield size={12} className="mr-1" />
                            Баталгаажсан
                          </span>
                        ) : (
                          <span className="badge badge-warning">Баталгаажаагүй</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Contact Info */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
                      <FiMail className="text-blue-600 mt-1" size={20} />
                      <div>
                        <p className="text-xs text-gray-500 mb-1">Имэйл</p>
                        <p className="font-medium text-gray-900">{profile.email}</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
                      <FiPhone className="text-green-600 mt-1" size={20} />
                      <div>
                        <p className="text-xs text-gray-500 mb-1">Утасны дугаар</p>
                        <p className="font-medium text-gray-900">{profile.phone || 'Бүртгээгүй'}</p>
                      </div>
                    </div>

                    {profile.company_name && (
                      <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
                        <FiBriefcase className="text-purple-600 mt-1" size={20} />
                        <div>
                          <p className="text-xs text-gray-500 mb-1">Байгууллага</p>
                          <p className="font-medium text-gray-900">{profile.company_name}</p>
                        </div>
                      </div>
                    )}

                    {profile.tax_number && (
                      <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
                        <FiAward className="text-orange-600 mt-1" size={20} />
                        <div>
                          <p className="text-xs text-gray-500 mb-1">Регистр</p>
                          <p className="font-medium text-gray-900">{profile.tax_number}</p>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Address */}
                  {profile.address && (
                    <div className="p-4 bg-gray-50 rounded-lg">
                      <div className="flex items-start gap-3">
                        <FiMapPin className="text-red-600 mt-1" size={20} />
                        <div className="flex-1">
                          <p className="text-xs text-gray-500 mb-1">Хаяг</p>
                          <p className="text-gray-900">{profile.address}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Right: Account Stats */}
          <div className="space-y-6">
            {/* Account Type */}
            <div className="card">
              <h3 className="font-semibold text-gray-900 mb-4">Данс төрөл</h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
                  <span className="text-sm text-gray-700">Харилцагчийн төрөл</span>
                  <span className={`badge ${profile.customer_type === 'wholesale' ? 'badge-blue' : 'badge-green'}`}>
                    {profile.customer_type === 'wholesale' ? 'Бөөний' : 'Жижиглэн'}
                  </span>
                </div>

                {profile.discount_rate > 0 && (
                  <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
                    <span className="text-sm text-gray-700">Хөнгөлөлт</span>
                    <span className="font-bold text-green-700">
                      <FiPercent className="inline mr-1" size={14} />
                      {profile.discount_rate}%
                    </span>
                  </div>
                )}

                {profile.payment_terms > 0 && (
                  <div className="flex items-center justify-between p-3 bg-purple-50 rounded-lg">
                    <span className="text-sm text-gray-700">Төлбөрийн нөхцөл</span>
                    <span className="font-bold text-purple-700">
                      <FiCalendar className="inline mr-1" size={14} />
                      {profile.payment_terms} хоног
                    </span>
                  </div>
                )}

                {profile.tax_exempt && (
                  <div className="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
                    <span className="text-sm text-gray-700">НӨАТ</span>
                    <span className="badge badge-yellow">Чөлөөлөгдсөн</span>
                  </div>
                )}
              </div>
            </div>

            {/* Credit Info */}
            {profile.customer_type === 'wholesale' && (
              <div className="card">
                <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                  <FiCreditCard className="text-blue-600" />
                  Зээлийн мэдээлэл
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="flex items-center justify-between text-sm mb-2">
                      <span className="text-gray-600">Нийт лимит</span>
                      <span className="font-bold text-gray-900">
                        ₮{(profile.credit_limit || 0).toLocaleString()}
                      </span>
                    </div>
                    <div className="flex items-center justify-between text-sm mb-2">
                      <span className="text-gray-600">Ашигласан</span>
                      <span className="font-bold text-red-600">
                        ₮{(profile.credit_used || 0).toLocaleString()}
                      </span>
                    </div>
                    <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-blue-600 transition-all"
                        style={{
                          width: `${Math.min(
                            ((profile.credit_used || 0) / (profile.credit_limit || 1)) * 100,
                            100
                          )}%`
                        }}
                      />
                    </div>
                  </div>

                  <div className="pt-4 border-t border-gray-200">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600 flex items-center gap-1">
                        <FiTrendingUp className="text-green-600" />
                        Боломжит дүн
                      </span>
                      <span className="text-xl font-bold text-green-600">
                        ₮{(profile.credit_available || 0).toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Account Status */}
            <div className="card">
              <h3 className="font-semibold text-gray-900 mb-4">Харилцагчийн төлөв</h3>
              <div className="space-y-3">
                {/* Идэвхтэй эсэх */}
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <span className="text-sm text-gray-700">Идэвхтэй эсэх</span>
                  {profile.is_active ? (
                    <span className="badge badge-success flex items-center gap-1">
                      <FiCheckCircle size={12} />
                      Идэвхтэй
                    </span>
                  ) : (
                    <span className="badge badge-danger flex items-center gap-1">
                      <FiXCircle size={12} />
                      Идэвхгүй
                    </span>
                  )}
                </div>

                {/* Баталгаажилт */}
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <span className="text-sm text-gray-700">Баталгаажилт</span>
                  {profile.verified ? (
                    <span className="badge badge-success flex items-center gap-1">
                      <FiShield size={12} />
                      Баталгаажсан
                    </span>
                  ) : (
                    <span className="badge badge-warning flex items-center gap-1">
                      <FiAlertCircle size={12} />
                      Баталгаажаагүй
                    </span>
                  )}
                </div>

                {/* Тайлбар */}
                {(!profile.is_active || !profile.verified) && (
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                    <p className="text-xs text-blue-700">
                      <strong>💡 Анхаар:</strong>
                      {!profile.is_active && !profile.verified && ' Таны данс идэвхгүй бөгөөд баталгаажаагүй байна. Админтай холбогдоно уу.'}
                      {!profile.is_active && profile.verified && ' Таны данс түр хаагдсан байна. Админтай холбогдоно уу.'}
                      {profile.is_active && !profile.verified && ' Таны данс баталгаажаагүй байна. Админ удахгүй баталгаажуулна.'}
                    </p>
                  </div>
                )}

                {/* Бүртгүүлсэн огноо */}
                {profile.created_at && (
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <span className="text-sm text-gray-700">Бүртгүүлсэн огноо</span>
                    <span className="text-sm font-medium text-gray-900">
                      {new Date(profile.created_at).toLocaleDateString('mn-MN')}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;